export default __webpack_public_path__ + "static/media/big_icon_red.6e3a2a70.svg";